import { render } from "./NewsFlashItem.vue?vue&type=template&id=b78efa50&scoped=true"
import script from "./NewsFlashItem.vue?vue&type=script&lang=js"
export * from "./NewsFlashItem.vue?vue&type=script&lang=js"

import "./NewsFlashItem.vue?vue&type=style&index=0&id=b78efa50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b78efa50"]])

export default __exports__